<template>
  <help-info-wrapper
      :info.sync="helpData"
      :service-name="serviceName"
      class="warp"
  >
    <template>
      <div>
        <custom-tabs v-model="tabs" class="mb-2" grow>
          <template v-slot:staticTabs>
            <v-tab :ripple="false">
              <div class="cornel-left"/>
              <div class="cornel-right"/>
              رنگ صفحه
              <help-info
                  :element-name="`${serviceName}-${componentName}-change-color-header`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('change_header_color')"
              />
            </v-tab>
            <v-tab :ripple="false">
              <div class="cornel-left"/>
              <div class="cornel-right"/>
              رنگ دکمه
              <help-info
                  :element-name="`${serviceName}-${componentName}-change-color-header`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('change_header_color')"
              />
            </v-tab>
            <v-tab :ripple="false">
              <div class="cornel-left"/>
              <div class="cornel-right"/>
              رنگ متن
              <help-info
                  :element-name="`${serviceName}-${componentName}-change-color-header`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('change_header_color')"
              />
            </v-tab>
          </template>

          <template v-slot:middle>
            <v-switch
                v-if="tabs <= 1"
                v-model="gradient"
                class="py-0"
                :label="$t('gradient_colors')"
            />
          </template>

          <template v-slot:staticItems>

            <v-tab-item>
              <v-card class="rounded-lg pa-md-2" outlined>
                <v-row class="mx-auto mt-4" no-gutters>
                  <template v-if="gradient">
                    <v-col class="pa-2" cols="12" md="6">
                      <v-card flat max-width="200">
                        <div class="rowinfo">
                          <v-autocomplete
                              v-model="body.dir"
                              :items="direction"
                              dense
                              hide-details
                              item-text="text"
                              item-value="value"
                              :label="$t('color_direction')"
                              class="contentinfo"
                              outlined
                          />
                        </div>
                      </v-card>
                    </v-col>

                    <v-col class="pa-2 d-none d-md-block" cols="12" md="6"/>

                    <v-col class="pa-2" cols="12" md="6">
                      <color-picker
                          v-model="body.color1"
                          :label="$t('first_color')"
                      />
                    </v-col>

                    <v-col class="pa-2" cols="12" md="6">
                      <color-picker
                          v-model="body.color2"
                          :label="$t('second_color')"
                      />
                    </v-col>
                  </template>

                  <v-col v-else class="pa-2" cols="12" md="6">
                    <color-picker
                        v-model="body.color2"
                        @input="updateSolidBody"
                        :label="$t('color')"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card class="rounded-lg pa-md-2" outlined>
                <v-row class="mx-auto mt-4" no-gutters>
                  <template v-if="gradient">
                    <v-col class="pa-2" cols="12" md="6">
                      <v-card flat max-width="200">
                        <div class="rowinfo">
                          <v-autocomplete
                              v-model="button.dir"
                              :items="direction"
                              dense
                              hide-details
                              item-text="text"
                              item-value="value"
                              :label="$t('color_direction')"
                              class="contentinfo"
                              outlined
                          />
                        </div>
                      </v-card>
                    </v-col>

                    <v-col class="pa-2 d-none d-md-block" cols="12" md="6"/>

                    <v-col class="pa-2" cols="12" md="6">
                      <color-picker
                          v-model="button.color1"
                          :label="$t('first_color')"
                      />
                    </v-col>

                    <v-col class="pa-2" cols="12" md="6">
                      <color-picker
                          v-model="button.color2"
                          :label="$t('second_color')"
                      />
                    </v-col>

                  </template>

                  <v-col v-else class="pa-2" cols="12" md="6">
                    <color-picker
                        v-model="button.color2"
                        @input="updateSolidButton"
                        :label="$t('color')"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card class="rounded-lg pa-md-2" outlined>
                <v-row class="mx-auto mt-4" no-gutters>
                  <v-col class="pa-2" cols="12" md="6">
                    <color-picker
                        v-model="colorObj.textColor"
                        :label="$t('color')"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

          </template>
        </custom-tabs>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import {Bus} from "./../../../../main";
import HelpInfo from "@/view/pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "@/view/pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";

export default {
  name: "ManagementColor",

  components: {ColorPicker, HelpInfo, HelpInfoWrapper},

  props: {
    value: Object,
    data: [Object, Array],
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "colorpallete",
      tabs: 0,

      // آبجکت اصلی که به والد ارسال می‌شود
      colorObj: {
        bodyColor: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
        buttonColor: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
        textColor: "#2115A7FF",
      },

      // متغیرهای داخلی
      body: {
        dir: "to top left",
        color1: "#D81A1AFF",
        color2: "#2115A7FF",
      },
      button: {
        dir: "to top left",
        color1: "#D81A1AFF",
        color2: "#2115A7FF",
      },
      // text نیازی به آبجکت پیچیده ندارد چون گرادینت نیست

      gradient: true,
    };
  },

  mounted() {
    this.setColors();
  },

  computed: {
    direction() {
      return [
        {text: this.$t("from_top"), value: "to top"},
        {text: this.$t("from_bottom"), value: "to bottom"},
        {text: this.$t("from_left_to_right"), value: "to right"},
        {text: this.$t("from_right_to_left"), value: "to left"},
        {text: this.$t("from_top_to_left"), value: "to top left"},
        {text: this.$t("from_top_to_right"), value: "to top right"},
        {text: this.$t("from_bottom_to_left"), value: "to bottom left"},
        {text: this.$t("from_bottom_to_right"), value: "to bottom right"},
      ];
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    value: {
      handler(val) {
        // جلوگیری از لوپ بی نهایت اگر تغییر از داخل خود کامپوننت باشد
        if (JSON.stringify(val) !== JSON.stringify(this.colorObj)) {
          this.setColors();
        }
      },
      deep: true
    },

    // وقتی colorObj تغییر کرد به والد خبر بده
    colorObj: {
      handler(value) {
        this.$emit("input", value);
        Bus.$emit("colorUpdate", value);
      },
      deep: true,
    },

    gradient: {
      handler(val) {
        Bus.$emit("gradientType", val);

        // نکته مهم: اینجا اصلا به textColor کاری نداریم
        if (!val) {
          // حالت سالید
          this.colorObj.bodyColor = this.body.color2;
          this.colorObj.buttonColor = this.button.color2;
        } else {
          // حالت گرادینت
          this.updateGradientColor('body');
          this.updateGradientColor('button');
        }
      },
      // deep لازم نیست چون بولین است
    },

    body: {
      handler() {
        if (this.gradient) {
          this.updateGradientColor('body');
        } else {
          // اگر گرادینت خاموش است و تغییری در color2 ایجاد شده (توسط color picker)
          // متد updateSolidBody هندل می‌کند اما اینجا محض اطمینان
          this.colorObj.bodyColor = this.body.color2;
        }
        Bus.$emit("bodyColor", this.body);
      },
      deep: true,
    },

    button: {
      handler() {
        if (this.gradient) {
          this.updateGradientColor('button');
        } else {
          this.colorObj.buttonColor = this.button.color2;
        }
        Bus.$emit("buttonColor", this.button);
      },
      deep: true,
    },
  },

  methods: {
    // توابع کمکی برای آپدیت رنگ‌ها
    updateSolidBody(val) {
      this.colorObj.bodyColor = val;
    },
    updateSolidButton(val) {
      this.colorObj.buttonColor = val;
    },
    updateGradientColor(type) {
      if (type === 'body') {
        this.colorObj.bodyColor = `linear-gradient(${this.body.dir} , ${this.body.color1}, ${this.body.color2})`;
      } else if (type === 'button') {
        this.colorObj.buttonColor = `linear-gradient(${this.button.dir} , ${this.button.color1}, ${this.button.color2})`;
      }
    },

    setColors() {
      if (this.value) {
        // کپی کردن مقادیر بدون ارجاع مستقیم (برای اطمینان)
        this.colorObj = { ...this.value };

        // 1. تنظیم رنگ بدنه
        this.parseColor(this.value.bodyColor, 'body');

        // 2. تنظیم رنگ دکمه (اگر وجود دارد، اگر نه مشابه بادی)
        if (this.value.buttonColor) {
          this.parseColor(this.value.buttonColor, 'button');
        }

        // 3. تنظیم رنگ متن (فقط رشته است)
        if (this.value.textColor) {
          this.colorObj.textColor = this.value.textColor;
        }

      } else {
        // مقادیر پیش‌فرض
        this.colorObj = {
          bodyColor: "linear-gradient(to bottom left , #170000, #FF0000)",
          buttonColor: "linear-gradient(to bottom left , #170000, #FF0000)",
          textColor: "#ffffff",
        };
        this.gradient = true;
      }
    },

    parseColor(colorString, type) {
      if (!colorString) return;

      const isGradient = colorString.includes('gradient');
      // اگر هر کدام از رنگ‌ها گرادینت بود، سوئیچ را روشن کن
      if (isGradient) this.gradient = true;
      else if (type === 'body') this.gradient = false; // اولویت با بادی است برای تعیین وضعیت اولیه

      if (isGradient) {
        try {
          // تلاش برای استخراج رنگ‌ها از رشته گرادینت
          // فرمت: linear-gradient(dir, color1, color2)
          // استفاده از regex ساده‌تر و امن‌تر
          const matches = colorString.match(/linear-gradient\((.*)\)/);
          if (matches && matches[1]) {
            const parts = matches[1].split(',').map(s => s.trim());

            // بخش جهت (Direction)
            const dir = parts[0];

            // رنگ‌ها (ممکن است هگز یا rgb باشند، فرض بر ساده بودن یعنی جدا شدن با کاما)
            // اگر فرمت رنگ‌ها پیچیده باشد (مثل rgba) این split ساده ممکن است خطا دهد
            // برای سادگی فرض می‌کنیم هگز هستند:
            let c1 = parts[1];
            let c2 = parts[2];

            // اصلاح برای حالتی که با کاما جدا شده‌اند ولی جهت شامل space است
            // روش بهتر: پیدا کردن تمام کدهای رنگی که با # شروع می‌شوند
            const colors = matches[1].match(/#[0-9a-fA-F]{6,8}/g);

            if (type === 'body') {
              this.body.dir = dir.includes('to') ? dir : 'to top left';
              if (colors && colors.length >= 2) {
                this.body.color1 = colors[0];
                this.body.color2 = colors[1];
              }
            } else {
              this.button.dir = dir.includes('to') ? dir : 'to top left';
              if (colors && colors.length >= 2) {
                this.button.color1 = colors[0];
                this.button.color2 = colors[1];
              }
            }
          }
        } catch (e) {
          console.error("Error parsing gradient:", e);
        }
      } else {
        // حالت رنگ ساده (Solid)
        if (type === 'body') {
          this.body.color2 = colorString; // در حالت سالید معمولا یکی از متغیرها استفاده می‌شود
        } else {
          this.button.color2 = colorString;
        }
      }
    }
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.sp-wrapper {
  padding: 12px 0;
  border-bottom: 1px dashed rgb(126, 130, 153);
}
</style>